"use client";

import React from "react";
import { cn } from "utils";
import { OspModal } from "@ospweb/sdk-ui";
import Translations from "@translate/components/Portfolio/Header/DeleteConfirmModal/DeleteConfirmModal";
import { I18nUtil } from "@utils/i18n";
import { useIsPc } from "@/src/hooks";

const I18n = I18nUtil.createScoped(Translations);
export interface DeleteConfirmModalProps {
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  loading = false,
  disabled = false,
  className,
}) => {
  const [isPC] = useIsPc();
  return (
    <OspModal
      open={isOpen}
      onCancel={() => !disabled && !loading && onCancel?.()}
      centered
      styles={{
        content: {
          width: isPC ? 400 : "calc(100vw - 72px)",
          paddingBottom: 12,
        },
      }}
      // 关闭按钮走 onCancel，键盘/遮罩行为由内部处理
      title={null}
    >
      <div
        className={cn(className)}
        data-testid="delete-confirm-modal"
        aria-labelledby="delete-modal-title"
        aria-describedby="delete-modal-desc"
      >
        <div className="flex flex-col gap-3">
          <div
            id="delete-modal-title"
            className="headline_regular_s text-content_primary"
          >
            {I18n.t("Delete portfolio?")}
          </div>
          <div id="delete-modal-desc" className="body_m text-content_secondary">
            {I18n.t("Delete means delete, this portfolio won't come back.")}
          </div>
        </div>

        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            aria-label="Delete Confirm Modal"
            data-openreplay-label={`Delete Confirm Modal Button | ${I18n.t("Cancel")}`}
            id="btn-delete-confirm-modal"
            type="button"
            className="secondary_button sm_button button_m text-content_primary min-w-[80px]"
            onClick={() => !disabled && !loading && onCancel?.()}
            disabled={disabled || loading}
            data-testid="delete-cancel"
          >
            {I18n.t("Cancel")}
          </button>
          <button
            aria-label="Delete Confirm Modal"
            data-openreplay-label={`Delete Confirm Modal Button | ${I18n.t("Confirm")}`}
            id="btn-delete-confirm-modal-2"
            type="button"
            className="primary_button sm_button button_m min-w-[80px]"
            onClick={() => !disabled && !loading && onConfirm?.()}
            disabled={disabled || loading}
            data-testid="delete-confirm"
          >
            {I18n.t("Confirm")}
          </button>
        </div>
      </div>
    </OspModal>
  );
};
